import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { 
  faSignInAlt, 
  faLock, 
  faUser, 
  faKey, 
  faExclamationCircle,
  faCheckCircle,
  faUsersCog
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FontAwesomeModule
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  // FontAwesome icons
  faSignInAlt = faSignInAlt;
  faLock = faLock;
  faUser = faUser;
  faKey = faKey;
  faExclamationCircle = faExclamationCircle;
  faCheckCircle = faCheckCircle;
  faUsersCog = faUsersCog;

  loginForm: FormGroup;
  isLoading: boolean = false;
  errorMessage: string = '';
  successMessage: string = '';
  username: string = '';
  userRole: string = '';
  authToken: string = '';

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(3)]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  ngOnInit(): void {
  }

  onSubmit() {
    if (this.loginForm.invalid) {
      // Mark all fields as touched to trigger validation messages
      Object.keys(this.loginForm.controls).forEach(key => {
        this.loginForm.get(key)?.markAsTouched();
      });
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.successMessage = '';

    this.http.post('/api/auth/login', this.loginForm.value).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        this.username = response.user.username;
        this.userRole = response.user.role;
        this.authToken = response.token;
        this.successMessage = 'Login successful!';
        
        localStorage.setItem('auth_token', response.token);
        localStorage.setItem('username', response.user.username);
        localStorage.setItem('userRole', response.user.role);
        if (response.user.company_id) {
          localStorage.setItem('companyId', response.user.company_id);
        }
        
        setTimeout(() => {
          this.router.navigate(['/hr/dashboard'], {
            queryParams: { token: response.token }
          });
        }, 2000);
      },
      error: (error) => {
        this.isLoading = false;
        this.errorMessage = error.error.message || 'Login failed. Please try again.';
      }
    });
  }
} 